import { render } from "./aiCategSplit.vue?vue&type=template&id=94421566"
import script from "./aiCategSplit.vue?vue&type=script&lang=js"
export * from "./aiCategSplit.vue?vue&type=script&lang=js"

import "./aiCategSplit.vue?vue&type=style&index=0&id=94421566&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__